import type { InvoiceStatus } from './dtos/wire';

/**
 * Statuses where the on-screen preview must show the issued artefact
 * (preview JPG / cached render), not a live customizable artboard.
 * Includes `pending` (send pipeline in flight) and all post-issue states.
 */
export function isInvoicePreviewFrozen(status: InvoiceStatus): boolean {
  return status !== 'draft';
}

/** Only drafts get the customize toolbar and live org branding overlay. */
export function isInvoicePreviewCustomizable(status: InvoiceStatus): boolean {
  return status === 'draft';
}
